import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import {
  AVATAR_STYLES,
  BADGE_STYLES,
  BREADCRUMB_STYLES,
  BUTTON_STYLES,
  CASCADESELECT_STYLES,
  CHECKBOX_STYLES,
  DIALOG_STYLES,
  DRAWER_STYLES,
  PANEL_STYLES,
  SELECT_STYLES,
  DATA_TABLE_STYLES,
  DATEPICKER_STYLES,
  TOAST_STYLES,
  TOOLTIP_STYLES,
  PROGRESS_SPINNER_STYLES,
  TABS_STYLES,
  MULTISELECT_STYLES,
  TREE_TABLE_STYLES,
  FILE_UPLOAD_STYLES,
  MENU_ITEM_STYLES,
  INPUT_STYLES,
  INPUT_TEXT_STYLES,
  INPUTGROUP_STYLES,
  SELECT_BUTTON_STYLES,
} from '@src/styles/preset/components';

export const ComexPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: 'var(--color-comex-50)',
      100: 'var(--color-comex-100)',
      200: 'var(--color-comex-200)',
      300: 'var(--color-comex-300)',
      400: 'var(--color-comex-400)',
      500: 'var(--color-comex-500)',
      600: 'var(--color-comex-600)',
      700: 'var(--color-comex-700)',
      800: 'var(--color-comex-800)',
      900: 'var(--color-comex-900)',
      950: 'var(--color-comex-950)',
    },
    error: 'var(--color-red-600)',
  },
  components: {
    avatar: AVATAR_STYLES,
    badge: BADGE_STYLES,
    breadcrumb: BREADCRUMB_STYLES,
    cascadeselect: CASCADESELECT_STYLES,
    button: BUTTON_STYLES,
    checkbox: CHECKBOX_STYLES,
    datatable: DATA_TABLE_STYLES,
    datepicker: DATEPICKER_STYLES,
    dialog: DIALOG_STYLES,
    drawer: DRAWER_STYLES,
    fileupload: FILE_UPLOAD_STYLES,
    inputgroup: INPUTGROUP_STYLES,
    inputnumber: INPUT_STYLES,
    inputtext: INPUT_TEXT_STYLES,
    menu: MENU_ITEM_STYLES,
    multiselect: MULTISELECT_STYLES,
    panel: PANEL_STYLES,
    progressspinner: PROGRESS_SPINNER_STYLES,
    selectbutton: SELECT_BUTTON_STYLES,
    select: SELECT_STYLES,
    tabs: TABS_STYLES,
    toast: TOAST_STYLES,
    tooltip: TOOLTIP_STYLES,
    treetable: TREE_TABLE_STYLES,
  },
});
